// @flow

import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import oauthReducers from './oauth-reducers';
import commonReducers from './common-reducers';
import installReducers from './install-reducers';
import setupReducers from './setup-reducers';
import dashboardReducers from './dashboard-reducers';
import dashboardV3Reducers from './dashboard-v3-reducers';
import syncReducers from './sync-reducers';
import notificationReducers from './dashboard/notification-reducers';
import optionEmailReducers from './dashboard/option-email.reducers';
import checklistReducers from './dashboard/checklist-reducers';
import quickStartGuideReducers from './dashboard/quick-start-guide-reducers';
import supportTicketReducers from './support-ticket-reducers';
import expReviewRatingReducers from './exp-review-rating-reducers';
import filterTreeReducers from './filter-tree/filter-tree-reducers';
import availableCollectionsReducers from './filter-tree/collection-reducers';
import filterDataReducers from './filter-data-reducers';
import managementFilterTreeReducers from './filter-tree/management-reducers';
import multiLevelReducers from './filter-tree/multi-level-reducers';
import filterSettingsReducers from './filter-settings-reducers';
import themeSetupReducers from './theme-setup-reducers';
import themeSetupV3Reducers from './theme-setup-v3-reducers';
import themeRevertReducers from './theme-revert-reducers';
import subscriptionReducers from './subscription-reducers';
import subscriptionV3Reducers from './subscription-v3-reducers';
import subscriptionV5Reducers from './subscription-v5-reducers';
import applicationChargeReducers from './application-charge-reducers';
import mergeValuesReducers from './merge-values-reducers';
import translationReducers from './translation-reducers';
import stopWordsReducers from './stop-words-reducers';
import suggestionDictionaryReducers from './suggestion-dictionary-reducers';
import synonymReducers from './synonym-reducers';
import redirectReducers from './redirect-reducers';
import productRankingReducers from './product-ranking-reducers';
import merchandisingReducers from './merchandising-reducers';
import merchandisingV2Reducers from './merchandising-v2-reducers';
import recommendationReducers from './recommendation-reducers';
import bundleReducers from './bundle-reducers';
import analyticsReducers from './analytics-reducers';
import analyticsV2Reducers from './analytics-v2-reducers';
import analyticsQueryExecutionIdReducers from './analytics-query-execution-id-reducers.js';
import appPermissionReducers from './app-permission-reducers';
import appIntegrationReducers from './app-integration-reducers.js';
import metafieldReducers from './metafield-reducers';
import productVisibilityReducers from './product-visibility-reducers';
import searchSettingsReducers from './search-settings-reducers';
import customRangeSliderReducers from './custom-range-slider-reducers';
import customSortingReducers from './custom-sorting-reducers';
import productReducers from './product-reducers';
import featureReducers from './feature-reducers';
import swatchSettingsReducers from './swatch-settings-reducers';
import defaultThemeSettingsReducers from './default-theme-settings-reducers';
import fontReducers from './font-reducers';
import filesReducers from './files-reducers';
import variantsDisplayReducers from './variants-display-reducers';
import themeSettingReducers from './theme-settings-reducers';
import integrationReducers from './integration-reducers';
import semanticReducers from './semantic-reducers';
import personalizationReducers from './personalization-reducers';
import productPerformanceRankingReducers from './product-performance-ranking-reducers';
import searchControlReducers from './search-control-reducers';
import searchPreviewReducers from './search-preview-reducers';
import klaviyoReducers from './klaviyo-reducers';
import csatRatingReducers from './csat-rating-reducers';
import preOrderReducers from './pre-order-reducers';
import generalSwatchReducers from './general-swatch-reducers';
import attentiveReducers from './attentive-reducers';

// Theme Integration with SSR
import shopifyIntegrationThemeReducers from './shopify-integration/theme-reducers';
import themeIntegrationReducers from './shopify-integration/theme-integration-reducers';
import templateInstanceReducers from './shopify-integration/template-instance-reducers';
import smartStylingReducers from './shopify-integration/smart-styling-reducers';
import shopifyIntegrationSettingsReducers from './shopify-integration/shopify-integration-settings-reducers';

const rootReducers = combineReducers({
  //form
  form: formReducer,
  oauth: oauthReducers,
  common: commonReducers,
  install: installReducers,
  setup: setupReducers,
  dashboard: dashboardReducers,
  dashboardV3: dashboardV3Reducers,
  sync: syncReducers,
  notifications: notificationReducers,
  checklist: checklistReducers,
  quickStartGuide: quickStartGuideReducers,
  optionEmail: optionEmailReducers,
  supportTicket: supportTicketReducers,
  expReviewRating: expReviewRatingReducers,
  filterTree: filterTreeReducers,
  availableCollections: availableCollectionsReducers,
  filterData: filterDataReducers,
  managementFilterTree: managementFilterTreeReducers,
  multiLevelFilterOption: multiLevelReducers,
  filterSettings: filterSettingsReducers,
  themeSetup: themeSetupReducers,
  themeSetupV3: themeSetupV3Reducers,
  themeRevert: themeRevertReducers,

  // Theme Integration with SSR
  shopifyIntegrationTheme: shopifyIntegrationThemeReducers,
  templateInstance: templateInstanceReducers,
  themeIntegration: themeIntegrationReducers,

  subscription: subscriptionReducers,
  subscriptionV3: subscriptionV3Reducers,
  subscriptionV5: subscriptionV5Reducers,
  applicationCharge: applicationChargeReducers,
  mergeValues: mergeValuesReducers,
  translation: translationReducers,
  stopWords: stopWordsReducers,
  suggestionDictionary: suggestionDictionaryReducers,
  synonym: synonymReducers,
  redirect: redirectReducers,
  productRanking: productRankingReducers,
  merchandising: merchandisingReducers,
  merchandisingV2: merchandisingV2Reducers,
  recommendation: recommendationReducers,
  bundle: bundleReducers,
  metafield: metafieldReducers,
  productVisibility: productVisibilityReducers,
  analytics: analyticsReducers,
  analyticsV2: analyticsV2Reducers,
  analyticsQueryExecutionId: analyticsQueryExecutionIdReducers,
  appPermission: appPermissionReducers,
  appIntegration: appIntegrationReducers,
  searchSettings: searchSettingsReducers,
  customRangeSlider: customRangeSliderReducers,
  customSorting: customSortingReducers,
  product: productReducers,
  feature: featureReducers,
  swatchSettings: swatchSettingsReducers,
  defaultThemeSettings: defaultThemeSettingsReducers,
  font: fontReducers,
  files: filesReducers,
  variantsDisplay: variantsDisplayReducers,
  themeSetting: themeSettingReducers,
  integration: integrationReducers,
  semantic: semanticReducers,
  personalization: personalizationReducers,
  productPerformanceRanking: productPerformanceRankingReducers,
  searchControl: searchControlReducers,
  searchPreview: searchPreviewReducers,
  shopifyIntegrationSettings: shopifyIntegrationSettingsReducers,
  smartStyling: smartStylingReducers,
  klaviyo: klaviyoReducers,
  csatRating: csatRatingReducers,
  preOrder: preOrderReducers,
  generalSwatch: generalSwatchReducers,
  attentive: attentiveReducers,
});

export default rootReducers;
